import { render, staticRenderFns } from "./RegisterDelivery.vue?vue&type=template&id=2445c91c&scoped=true&"
import script from "./RegisterDelivery.vue?vue&type=script&lang=js&"
export * from "./RegisterDelivery.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDelivery.vue?vue&type=style&index=0&id=2445c91c&scoped=true&lang=scss&"
import style1 from "./RegisterDelivery.vue?vue&type=style&index=1&id=2445c91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2445c91c",
  null
  
)

export default component.exports